"use strict";

const PureRenderMixin = React.addons.PureRenderMixin;
const DatePicker =  require("app/shared/components/DatePicker/date-picker");
const Button = require("app/shared/components/Button/button");
const Popbox = require("app/shared/components/Popover/popbox");

const DealWonPopbox = React.createClass({
  propTypes: {
    onSave: React.PropTypes.func.isRequired,
    selectedDate: React.PropTypes.string.isRequired,
    onDateChange: React.PropTypes.func.isRequired,
    anchor: React.PropTypes.object,
    onClose: React.PropTypes.func,
    isVisible: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      isVisible: true,
      onSave: () => {},
      onClose: () => {}
    };
  },

  render: function() {
    return (
      <Popbox 
        isVisible={this.props.isVisible}
        anchor={this.props.anchor}
        onClose={this.props.onClose}
      >
        <div className="bootstrap-agendor bg-white u-boxShadow-light br-4 b-light ovf-h">
          <div className="w-230 d-tc p-5 p-r dealLossReason-datePicker">
            <span className="ta-c d-b fs-16 mb-10 fw-bold c-darkGray">Quando foi ganho?</span>
            <DatePicker
              selectedDate={this.props.selectedDate}
              onSelectDate={this.props.onDateChange} />
          </div>
          <Button className="w-100 fs-12 fw-600 mt-10" type="success" onClick={this.props.onSave}>Salvar</Button>
        </div>
      </Popbox>
    );
  }
});

module.exports = DealWonPopbox;



// WEBPACK FOOTER //
// ./app/shared/components/DealWonPopbox/deal-won-popbox.jsx